import { render } from "./ExperienceSingle.vue?vue&type=template&id=c0896a8a"
import script from "./ExperienceSingle.vue?vue&type=script&lang=js"
export * from "./ExperienceSingle.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/aniketkabra.github.io/aniketkabra.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__